module.exports = __webpack_public_path__ + "static/media/footprint-calculator.bb531173.gif";